import { Component, OnInit } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'app-vrsk-formly-repeat-type',
  templateUrl: './vrsk-formly-repeat-type.component.html',
  styleUrls: ['./vrsk-formly-repeat-type.component.scss']
})
export class VrskFormlyRepeatTypeComponent extends FieldArrayType implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
